module.exports = __webpack_public_path__ + "img/mamalous.892ace5b.jpg";